import type { CSSProperties } from 'react';
import logoSvgRaw from '../assets/logo.svg?raw';
import { prepareSvg } from './prepareSvg.ts';

const LOGO_SVG = prepareSvg(logoSvgRaw);

export interface LogoInlineProps {
  className?: string;
  style?: CSSProperties;
}

export function LogoInline({ className = 'h-6 md:h-7', style }: LogoInlineProps) {
  // dangerouslySetInnerHTML is fine here - content is a build-time asset.
  return (
    <span
      className={`inline-block ${className}`}
      style={{ ...style, lineHeight: 0 }}
      aria-label="Midtfyns Festival"
      dangerouslySetInnerHTML={{
        __html: LOGO_SVG.replace(
          '<svg',
          '<svg style="height:100%; width:auto; display:block;"',
        ),
      }}
    />
  );
}
